import React, {Component} from 'react';
import moment from 'moment';
import {
  fetchSalaryPayrollData
} from 'actions/SalaryActions';

class Payroll extends Component {
  state = {
    loading: true,
    error: false
  }

  pricing = (price) => {
    var part = price.toFixed(2).toString().split(".")[1];
    return [price.toLocaleString(), part].join(".")
  }

  componentDidMount() {
    let {uid, year, month} = this.props.params;
    fetchSalaryPayrollData(uid, year, month)
      .then((response) => {
        this.setState({
          loading: false,
          ...response.data
        })
      })
      .catch((error) => {
        this.setState({
          loading: false,
          error: true
        })
      })
  }

  render() {
    let {year, month} = this.props.params;
    let {
      daliySalary,
      shiftRecord,
      normalWU,
      otWU,
      adjustList,
      userName,
      position
    } = this.state;
    let adjustTotal = 0;
    let currentMonth = moment(year + month, 'YYYYMM');
    let daysInMonth = currentMonth.daysInMonth();
    return (!this.state.loading && 
      (
        this.state.error?
        <div className="payroll-report">
          <h4>
            報告不存在
          </h4>
        </div>
        :
        <div className="payroll-report">
          <h4>
            工數表
          </h4>
          <table className="user-info">
            <thead>
              <tr>
                <th colSpan={8}>
                  僱員資料
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>姓名：</td>
                <td>{userName}</td>
                <td>職位：</td>
                <td>{position}</td>
                <td>日薪：</td>
                <td>${this.pricing(daliySalary)}</td>
                <td>月份：</td>
                <td>{currentMonth.format("YYYY-MM")}</td>
              </tr>
            </tbody>
          </table>
          <table className="shift-info">
            <tbody>
              <tr>
                <th className="date">日期</th>
                <th className="shift">上午</th>
                <th className="shift">下午</th>
                <th className="shift">加班</th>
                <th className="date">日期</th>
                <th className="shift">上午</th>
                <th className="shift">下午</th>
                <th className="shift">加班</th>
              </tr>
              {[...Array(16).keys()].map((date)=> {
                date += 1;
                let next = date + 16;
                if (date < 10) date = "0" + date;
                return (
                  <tr>
                    <td className="date">{date}</td>
                    <td className="shift">{shiftRecord[date + '-0'] || '-'}</td>
                    <td className="shift">{shiftRecord[date + '-1'] || '-'}</td>
                    <td className="shift">{shiftRecord[date + '-2'] || '-'}</td>
                    <td className="date">{next <= daysInMonth? next : '-'}</td>
                    <td className="shift">{shiftRecord[next + '-0'] || '-'}</td>
                    <td className="shift">{shiftRecord[next + '-1'] || '-'}</td>
                    <td className="shift">{shiftRecord[next + '-2'] || '-'}</td>
                  </tr>
                )
              })}
            </tbody>
          </table>

          <table className="salary-info">
            <tbody>
              <tr className="shift-pay-info">
                <td>工數：</td>
                <td>{normalWU}</td>
                <td>加班：</td>
                <td>{otWU}</td>
                <td>總工數：</td>
                <td>{normalWU + otWU}</td>
                <td>工資：</td>
                <td>${this.pricing((normalWU + otWU) * daliySalary)}</td>
              </tr>
              <tr>
                <th colSpan={8}>
                  其他收入/扣款
                </th>
              </tr>
              {
                adjustList.map(adjust => {
                  let {type, note, amount} = adjust;
                  adjustTotal += amount;
                  return (
                    <tr>
                      <td colSpan={7}>
                        {type} 
                        {note && " - " + note}
                      </td>
                      <td>
                        {amount < 0 && "-"}
                        ${this.pricing(Math.abs(amount))}
                      </td>
                    </tr>
                  )
                })
              }
              <tr>
                <td className="total" colSpan={7}>
                  淨薪金
                </td>
                <td>
                  ${this.pricing((normalWU + otWU) * daliySalary + adjustTotal)}
                </td>
              </tr>
            </tbody>
          </table>
          <div className="sign">
            簽名：
          </div>
        </div>
      )
    )
  }
}

export default Payroll;


// WEBPACK FOOTER //
// ./src/components/Report/Payroll.js